export enum VendorStatus {
	//TABLE Ref_VendorStatus

	Active = 1,
	Inactive = 2,
}
